import React from "react";
import { Link } from "react-router-dom";

import "./styling/Button.css";

const Button = (props) => {
  if (props.href) {
    return (
      <a
        className={`button button--${props.size || "default"} ${
          props.inverse && "button--inverse"
        } ${props.danger && "button--danger"} ${props.className || ""}`}
        href={props.href}
        target={props.target}
        rel={props.target === "_blank" ? "noopener noreferrer" : undefined}
      >
        {props.children}
      </a>
    );
  }
  if (props.to) {
    return (
      <Link
        to={props.to}
        exact={props.exact}
        className={`button button--${props.size || "default"} ${
          props.inverse && "button--inverse"
        } ${props.danger && "button--danger"} ${props.className || ""}`}
      >
        {props.children}
      </Link>
    );
  }
  return (
    <button
      className={`button button--${props.size || "default"} ${
        props.inverse && "button--inverse"
      } ${props.danger && "button--danger"} ${props.className}`}
      id={props.id}
      type={props.type}
      onClick={props.onClick}
      disabled={props.disabled}
      form={props.form}
      title={props.title}
      aria-label={props["aria-label"]}
    >
      {props.children}
    </button>
  );
};

export default Button;
